function sendGoogleAnalyticsSearchCriteria(searchCriteria) {
  if (window.ga) {
    ga('send', 'event', 'search', 'executeSearch', searchCriteria);
  }
}
export default sendGoogleAnalyticsSearchCriteria;
